import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/canada/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/canada/images/heroBg.png";

import canada from "../../images/v4/country/canada/icons/canada.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/canada/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/canada/images/countryBackground.png";
import benefitImg from "../../images/v4/country/canada/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/canada/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/canada/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/canada/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/canada/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(93deg, #F00 0.73%, #FF9500 100.97%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#FFF8F5",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(270deg, #00B181 -3.46%, #1448C4 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Canada = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "What is CRM in Canada?",
      answer: (
        <>
          CRM in Canada is software that helps businesses manage customer
          interactions, streamline processes, and improve satisfaction. CRM
          software in Canada centralizes data, automates tasks, and enhances
          communication, making it essential for CRM companies in Canada.
        </>
      ),
    },
    {
      question: "How to get a CRM for your Canadian growing business?",
      answer: (
        <>
          <ul>
            <li>
              Identify your sales, marketing, and support needs for the right
              CRM software in Canada.
            </li>
            <li>
              Explore top choices like Pepper Cloud CRM, Salesforce, Zoho CRM,
              HubSpot CRM, and Freshsales.
            </li>
            <li>
              Choose CRM companies in Canada that offer strong local support and
              data compliance.
            </li>
            <li>
              Test platforms with free trials or demos to match your business
              goals.
            </li>
            <li>
              Ensure the best sales CRM software in Canada offers scalability
              and easy integrations.
            </li>
            <li>
              Prioritise data security and Canadian regulation compliance when
              selecting a CRM.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How to choose the best CRM for your Canadian business?",
      answer: (
        <>
          <ul>
            <li>
              Define your business goals before selecting CRM software in
              Canada.
            </li>
            <li>
              Compare features of Pepper Cloud CRM, Salesforce, Zoho CRM,
              HubSpot CRM, and Freshsales.
            </li>
            <li>
              Look for the best sales CRM software Canada with multichannel
              support and automation.
            </li>
            <li>
              Choose CRM companies in Canada that offer local customer service
              and compliance with Canadian laws.
            </li>
            <li>
              Prioritise ease of use, scalability, and customisation when
              selecting Canada CRM software.
            </li>
            <li>
              Ensure real-time analytics and integration options for better
              growth with CRM software in Canada.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM compare to other CRM companies in Canada?",
      answer: (
        <>
          Pepper Cloud CRM distinguishes itself among CRM companies in Canada by
          providing a comprehensive suite of features, including AI-driven
          insights, seamless WhatsApp integration, and customisable dashboards.
          Its focus on local market needs positions it as a leading CRM software
          solution.
        </>
      ),
    },
    {
      question:
        "Are there CRM software options in Canada that offer WhatsApp integration?",
      answer: (
        <>
          Yes, Pepper Cloud CRM stands out as the best sales CRM software in
          Canada with robust WhatsApp integration. This feature allows
          businesses to engage customers directly through one of Canada's
          popular messaging platforms, enhancing communication and marketing
          efforts.
        </>
      ),
    },
    {
      question:
        "What are the key features to look for in CRM software in Canada?",
      answer: (
        <>
          When selecting CRM software in Canada, consider features such as
          AI-driven insights, multichannel communication, lead management,
          customisable dashboards, and seamless integration with existing tools.
          The best sales CRM software in Canada should also offer scalability to
          accommodate business growth.
        </>
      ),
    },
    {
      question: "What are some best practices for using a CRM?",
      answer: (
        <>
          An advanced CRM can help to create a seamless buyer's journey and
          provide a wealth of data that can be used to improve marketing
          strategies. However, there are a few best practices to get the most
          out of a CRM:
          <ul>
            <li>
              Ensure that all data is entered into the system accurately and
              promptly.
            </li>
            <li>
              Perform regular clean-ups and updates to keep the data accurate
              and organized.
            </li>
            <li>
              Train all employees using the system to use it properly to avoid
              errors.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "What kind of support do CRM companies in Canada offer to their clients?",
      answer: (
        <>
          CRM companies in Canada provide various support options, including
          online resources, customer service hotlines, and dedicated account
          managers. Pepper Cloud CRM, for example, offers comprehensive support
          with training sessions and responsive customer service tailored to
          Canadian businesses.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Freshsales",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the best sales CRM software in Canada, offering a comprehensive suite tailored to the Canadian market. This all-in-one CRM software Canada combines powerful lead management, AI-driven insights, and seamless multichannel integration—perfect for businesses of all sizes.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-powered suite",
          desc: "Leverage chatbots, real-time sales assistance, and automated task management to optimise Canadian operations with CRM software Canada.",
        },
        {
          title: "Multichannel broadcast",
          desc: "Engage customers via email, SMS, social, and WhatsApp using the best sales CRM software in Canada.",
        },
        {
          title: "Lead management",
          desc: "Capture and track prospects with web forms and UTM tracking in CRM software in Canada.",
        },
        {
          title: "Omnichannel connectivity",
          desc: "Manage interactions across voice, video, social media and messaging apps with CRM software Canada.",
        },
        {
          title: "Automated workflows",
          desc: "Streamline sales and marketing with time‑ and event‑based automations in the best sales CRM software Canada.",
        },
        {
          title: "Customisable dashboards",
          desc: "Create bespoke visualisations and reports using CRM software Canada.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is a CRM software Canada solution known among CRM companies in Canada for its intuitive contact management and built-in marketing automation. With features like a pipeline builder and a free tier option, HubSpot CRM helps Canadian teams align sales and marketing with minimal setup and easy adoption.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Pipeline builder",
          desc: "Drag‑and‑drop customisation to match your unique sales processes in CRM software Canada.",
        },
        {
          title: "Marketing automation",
          desc: "Design, execute, and measure campaigns seamlessly with CRM software Canada.",
        },
        {
          title: "Free tier",
          desc: "Access core CRM features at no cost—ideal for startups exploring CRM software in Canada.",
        },
        {
          title: "Integration ecosystem",
          desc: "Extend functionality through hundreds of apps recognised by CRM companies in Canada.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is the CRM software provides customisation and enterprise-grade security. Its AppExchange marketplace and Einstein AI insights make it the go-to choice for large organisations seeking the best sales CRM software in Canada.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "AppExchange marketplace",
          desc: "Discover industry-specific apps and integrations optimised for CRM software in Canada.",
        },
        {
          title: "Einstein AI",
          desc: "Use predictive analytics and smart recommendations in the best sales CRM software in Canada.",
        },
        {
          title: "Customisable workflows",
          desc: "Automate complex processes to suit your business needs with CRM software Canada.",
        },
        {
          title: "Advanced reporting",
          desc: "Gain deep insights and reporting capabilities standard among CRM companies in Canada.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers an affordable CRM software solution, earning praise from CRM companies in Canada for its balance of features and cost. With Zia AI assistance and multichannel communication tools, Zoho CRM enables small and medium-sized Canadian businesses to compete effectively.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Predictive sales recommendations and task automation within CRM software in Canada.",
        },
        {
          title: "Multichannel communication",
          desc: "Manage email, phone, live chat, and social interactions using CRM software in Canada.",
        },
        {
          title: "Customisable modules",
          desc: "Tailor the CRM to specific workflows and departments with CRM software Canada.",
        },
        {
          title: "Gamification features",
          desc: "Motivate sales teams through performance-based rewards in the best sales CRM software in Canada.",
        },
      ],
    },
    {
      title: "Freshsales",
      desc: "Freshsales delivers a modern CRM software experience with visual sales pipelines, built-in phone and email, and advanced lead scoring. Endorsed by CRM companies in Canada as one of the Best Sales CRM software in Canada, Freshsales excels in usability and powerful automation.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "AI-driven lead scoring",
          desc: "Prioritise prospects intelligently within CRM software in Canada.",
        },
        {
          title: "Built-in communication",
          desc: "Make calls and send emails directly from the platform.",
        },
        {
          title: "Visual sales pipelines",
          desc: "Track deal stages with drag-and-drop simplicity.",
        },
        {
          title: "Workflow automations",
          desc: "Automate repetitive tasks using the best sales CRM software in Canada.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate tasks, allowing teams to focus on strategic activities. Essential for the Best Sales CRM software in Canada.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Centralise and track leads to ensure timely follow-ups and conversions. Key for CRM software in Canada.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Visual tools to track sales progress and close deals faster. Vital for CRM companies in Canada.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Streamline processes like follow-ups and lead routing. Crucial for businesses using Best Sales CRM software in Canada.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Engage clients via WhatsApp, ensuring seamless communication. A key feature for CRM software in Canada.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "Unify email, chat, and social media interactions. Important for CRM companies in Canada.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Prioritise tasks efficiently to improve sales team productivity. A valuable feature in Best Sales CRM software in Canada.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM App",
      desc: "Access CRM remotely, giving sales teams flexibility. Essential for businesses using CRM software in Canada.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Easily connect with other business tools for smooth workflows. Key for CRM companies in Canada.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Multichannel broadcast features",
          content:
            "Engage and retain members effectively with Pepper Cloud CRM software Canada.",
          alt: "Fitness and Wellness CRM",
        },
        {
          heading: "Personalized workouts",
          content: "Send custom fitness plans using CRM Canada.",
          alt: "Fitness and Wellness CRM",
        },
        {
          heading: "Class updates",
          content: "Share schedule changes via CRM software Canada.",
          alt: "Fitness and Wellness CRM",
        },
        {
          heading: "Motivational content",
          content: "Share success stories via CRM companies, Canada.",
          alt: "Fitness and Wellness CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Fitness and Wellness CRM for Canada",
      subtitle:
        "Gyms and fitness centres in Canada can harness Pepper Cloud CRM software Canada, voted the Best Sales CRM software Canada by leading CRM companies in Canada, for multichannel broadcast features that engage and retain members effectively.",
    },
    {
      tabContent: [
        {
          heading: "Automated follow-ups",
          content: "Schedule reminders in CRM software, Canada.",
          alt: "Sales Team Management CRM",
        },
        {
          heading: "Live product alerts",
          content: "Push real-time updates with CRM software, Canada.",
          alt: "Sales Team Management CRM",
        },
        {
          heading: "Performance dashboards",
          content: "Track metrics with CRM software, Canada.",
          alt: "Sales Team Management CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Sales Team Management CRM for Canada",
      subtitle:
        "Canadian sales teams benefit from Pepper Cloud as the Best Sales CRM software in Canada, powered by CRM software Canada solutions trusted among CRM companies in Canada.",
    },
    {
      tabContent: [
        {
          heading: "Order updates",
          content: "Auto-send shipment notifications via CRM in Canada.",
          alt: "Manufacturing Sector CRM",
        },
        {
          heading: "Inventory alerts",
          content: "Manage supplier communication via CRM in Canada.",
          alt: "Manufacturing Sector CRM",
        },
        {
          heading: "Product alerts",
          content: "Notify distributors of launches and restocks via CRM.",
          alt: "Manufacturing Sector CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Manufacturing Sector CRM for Canada",
      subtitle:
        "Canadian manufacturers can streamline operations and enhance client service with Pepper Cloud CRM software Canada, a top choice among CRM companies in Canada and the Best Sales CRM software Canada.",
    },
    {
      tabContent: [
        {
          heading: "Targeted promotions",
          content: "Send exclusive offers via CRM in Canada.",
          alt: "Retail Businesses CRM",
        },
        {
          heading: "Flash sale alerts",
          content: "Broadcast limited-time deals with CRM software.",
          alt: "Retail Businesses CRM",
        },
        {
          heading: "Loyalty management",
          content: "Automate rewards and track activity with CRM.",
          alt: "Retail Businesses CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail Businesses CRM for Canada",
      subtitle:
        "Pepper Cloud CRM software Canada—hailed as the Best Sales CRM software Canada by leading CRM companies in Canada—helps retailers drive sales with personalised marketing and loyalty management.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software Canada?",
      content:
        "CRM software Canada is designed to streamline business processes, manage customer relationships, and improve profitability. CRM companies in Canada deliver innovative solutions tailored for both startups and enterprises. Choosing the best sales CRM software in Canada helps businesses create efficient, consistent, and rewarding customer interactions.",
    },
    {
      heading: "Why do Canadian businesses need CRM software?",
      content:
        "CRM companies in Canada equip businesses with platforms to manage client data, elevate service standards, and accelerate growth. The best sales CRM software Canada offers scalable and affordable solutions for small businesses and large corporations alike. Partnering with trusted CRM companies in Canada guarantees improved productivity and a seamless customer experience.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM solution",
      desc: "Pepper Cloud combines sales, marketing, and support, securing its place as the best sales CRM software Canada provides.",
      img: bestIcon1,
    },
    {
      pointer: "AI-powered automation",
      desc: "Automate tasks and gain real-time insights, a feature loved by businesses seeking CRM software Canada solutions.",
      img: bestIcon2,
    },
    {
      pointer: "Customisable dashboards",
      desc: "Tailor your data visualisation — a hallmark of CRM companies in Canada.",
      img: bestIcon3,
    },
    {
      pointer: "Affordable pricing",
      desc: "Flexible plans make Pepper Cloud the best sales CRM software Canada has for growing companies.",
      img: bestIcon4,
    },
    {
      pointer: "24/7 Local support",
      desc: "Responsive customer support, trusted by businesses across Canada seeking reliable CRM software solutions.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Centralised customer data with CRM software Canada, improving organisation and eliminating data silos.",
    "Personalised customer engagement via CRM software in Canada, boosting satisfaction and loyalty.",
    "Enhanced sales visibility using Best Sales CRM software Canada, enabling smarter forecasting and prioritisation.",
    "Automated marketing campaigns through CRM software in Canada, freeing up time for strategic initiatives.",
  ];
  return (
    <main>
      <SEO
        title={
          "Best AI-powered sales CRM Software in Canada | Pepper Cloud CRM"
        }
        pathname={
          "https://peppercloud.com/country/country/best-sales-crm-software-canada"
        }
        keywords="Best Sales crm software Canada, CRM software Canada, What is CRM software Canada?"
        description={
          "Explore the best CRM software in Canada to streamline sales, improve customer relationships, and grow your business with smart, scalable solutions."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is CRM in Canada?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM in Canada is software that helps businesses manage customer interactions, streamline processes, and improve satisfaction. CRM software in Canada centralizes data, automates tasks, and enhances communication, making it essential for CRM companies in Canada.",
                },
              },
              {
                "@type": "Question",
                name: "How to get a CRM for your Canadian growing business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Identify your sales, marketing, and support needs for the right CRM software in Canada. Explore top choices like Pepper Cloud CRM, Salesforce, Zoho CRM, HubSpot CRM, and Freshsales. Choose CRM companies in Canada that offer strong local support and data compliance. Test platforms with free trials or demos to match your business goals. Ensure the best sales CRM software in Canada offers scalability and easy integrations. Prioritise data security and Canadian regulation compliance when selecting a CRM.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM for your Canadian business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Define your business goals before selecting CRM software in Canada. Compare features of Pepper Cloud CRM, Salesforce, Zoho CRM, HubSpot CRM, and Freshsales. Look for the best sales CRM software Canada with multichannel support and automation. Choose CRM companies in Canada that offer local customer service and compliance with Canadian laws. Prioritise ease of use, scalability, and customisation when selecting Canada CRM software. Ensure real-time analytics and integration options for better growth with CRM software in Canada.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM compare to other CRM companies in Canada?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM distinguishes itself among CRM companies in Canada by providing a comprehensive suite of features, including AI-driven insights, seamless WhatsApp integration, and customisable dashboards. Its focus on local market needs positions it as a leading CRM software solution.",
                },
              },
              {
                "@type": "Question",
                name: "Are there CRM software options in Canada that offer WhatsApp integration?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM stands out as the best sales CRM software in Canada with robust WhatsApp integration. This feature allows businesses to engage customers directly through one of Canada's popular messaging platforms, enhancing communication and marketing efforts.",
                },
              },
              {
                "@type": "Question",
                name: "What are the key features to look for in CRM software in Canada?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "When selecting CRM software in Canada, consider features such as AI-driven insights, multichannel communication, lead management, customisable dashboards, and seamless integration with existing tools. The best sales CRM software in Canada should also offer scalability to accommodate business growth.",
                },
              },
              {
                "@type": "Question",
                name: "What are some best practices for using a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "An advanced CRM can help to create a seamless buyer's journey and provide a wealth of data that can be used to improve marketing strategies. However, there are a few best practices to get the most out of a CRM: First, ensure that all data is entered into the system accurately and promptly. Perform regular clean-ups and updates to keep the data accurate and organized. Lastly, it is essential to train all employees using the system to use it properly to avoid errors.",
                },
              },
              {
                "@type": "Question",
                name: "What kind of support do CRM companies in Canada offer to their clients?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "CRM companies in Canada provide various support options, including online resources, customer service hotlines, and dedicated account managers. Pepper Cloud CRM, for example, offers comprehensive support with training sessions and responsive customer service tailored to Canadian businesses.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Best CRM Software{" "}
              <img className="countryLogo" src={canada} alt="Canada" />{" "}
              <span className="countryHighlight">Canada</span>: Transform
              Customer Connections
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Revolutionise your business operations with Pepper Cloud, the best
              sales CRM software in Canada. Enhance customer relationships,
              streamline workflows, and fuel growth with our all-in-one
              solution.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-powered automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Unified multichannel communication
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Real-time analytics
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about the best CRM software in Canada
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best sales CRM software Canada
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM system for your Canadian small business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Benefits of using a CRM system for your Canadian small business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Applications and use cases of Canada CRM software
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                 Fitness and wellness
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Sales team management
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Manufacturing
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Retail
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software in Canada in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQ's - Best CRM software in Canada"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Boost growth with the best CRM software in Canada
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Canada;
